"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInvalidGolfRates = void 0;
const orders_1 = require("../orders");
/**
 * Checks if any golf course in the itinerary has invalid rates (zero total)
 * @param formData - Form data containing course itinerary
 * @returns boolean - true if any course has invalid rates, false otherwise
 */
const hasInvalidGolfRates = (formData) => {
    if (!formData?.courses?.itinerary ||
        !Array.isArray(formData.courses.itinerary)) {
        return false;
    }
    return formData.courses.itinerary
        .filter(Boolean) // Filter out null/undefined items
        .some((golf) => (0, orders_1.getOrderLineTotalByType)(golf.config, "GOLF") === 0);
};
exports.hasInvalidGolfRates = hasInvalidGolfRates;
